(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salty-editable-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  const ratingWidgets = new WeakSet();
  const media = window.matchMedia('(max-width: 989px)');
  const preciseRating = widget => {
    const summary = widget.querySelector('.jdgm-all-reviews-text__text[data-score]');
    const stars = widget.querySelector('.jm-average-rating-display .jm-star-rating[aria-label]');
    const match = stars?.getAttribute('aria-label')?.match(/^(\d+(?:\.\d+)?) out of \d+ stars$/);
    const value = Number(summary?.getAttribute('data-score') ?? match?.[1]);
    if (!Number.isFinite(value) || value < 1 || value > 5) return;
    const precise = value.toFixed(2);
    const score = summary ? widget.querySelector('.jdgm-all-reviews-rating__score') : widget.querySelector('.jm-average-rating-display .jm-cluster > span.jm-text');
    if (score && score.textContent !== precise) score.textContent = precise;
    if (summary) {
      const label = summary.querySelector('a') || summary;
      const corrected = label.textContent.replace(/^\s*\d+(?:[.,]\d+)?(?=\s+out of\s+5\s+stars)/, precise);
      if (label.textContent !== corrected) label.textContent = corrected;
    } else if (stars) {
      const label = precise + ' out of 5 stars';
      if (stars.getAttribute('aria-label') !== label) stars.setAttribute('aria-label', label);
    }
  };
  const connectRatings = root => {
    const selector = '.jdgm-all-reviews-text,.jdgm-reviews-grid-widget';
    const widgets = root.nodeType === 1 && root.matches(selector) ? [root] : [];
    if (root.querySelectorAll) widgets.push(...root.querySelectorAll(selector));
    widgets.forEach(widget => {
      if (ratingWidgets.has(widget)) return;
      ratingWidgets.add(widget);
      preciseRating(widget);
      new MutationObserver(() => preciseRating(widget)).observe(widget,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['data-score','aria-label']});
    });
  };
  const initialize = root => {
    root.querySelectorAll('[data-sj-review-root]').forEach(section => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const form = section.querySelector('[data-sj-review-product]');
      if (form) form.addEventListener('submit',event => {
        const path = form.querySelector('select').value;
        const destination = new URL(path,window.location.origin);
        if (destination.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(destination.pathname)) return;
        event.preventDefault();
        window.location.assign(path);
      });
      const grid = section.querySelector('[data-sj-review-grid]');
      const controls = section.querySelector('[data-sj-review-controls]');
      if (!grid || !controls) return;
      const cards = [...grid.querySelectorAll('[data-sj-review-card]')];
      const previous = controls.querySelector('[data-sj-review-prev]');
      const next = controls.querySelector('[data-sj-review-next]');
      const counter = controls.querySelector('[data-sj-review-counter]');
      let active = 0;
      let scheduled = false;
      const update = () => {
        active = cards.reduce((closest,card,index) => Math.abs(card.getBoundingClientRect().left-grid.getBoundingClientRect().left) < Math.abs(cards[closest].getBoundingClientRect().left-grid.getBoundingClientRect().left) ? index : closest,0);
        counter.textContent = counter.dataset.counterLabel.replace('SJ_CURRENT',String(active+1)).replace('SJ_TOTAL',String(cards.length));
        previous.disabled = active === 0;
        next.disabled = active === cards.length-1;
      };
      const move = direction => {
        const index = Math.max(0,Math.min(cards.length-1,active+direction));
        grid.scrollTo({left:cards[index].offsetLeft-cards[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      controls.hidden = false;
      previous.addEventListener('click',()=>move(-1));
      next.addEventListener('click',()=>move(1));
      grid.addEventListener('scroll',()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;update();});},{passive:true});
      media.addEventListener('change',update);
      update();
      document.addEventListener('shopify:block:select',event=>{
        if (!media.matches) return;
        const card = event.target.closest('[data-sj-review-card]');
        if (card && grid.contains(card)) grid.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'auto'});
      });
    });
  };
  const start = () => {
    initialize(document);
    connectRatings(document);
    new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)connectRatings(node);}))).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',()=>initialize(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salty-partnerships"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-sjp-success], [data-sjp-errors]').forEach((notice) => {
      notice.focus({ preventScroll: true });
      notice.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["salty-reviews-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sectionStates = new WeakMap();
  const ratingSources = new WeakMap();
  const sectionsWithin = root => {
    const sections = root.matches?.('[data-sjrh]') ? [root] : [];
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-sjrh]'));
    return sections;
  };
  const preciseRating = (section,widget) => {
    const stars = widget.querySelector('.jm-average-rating-display .jm-star-rating[aria-label]');
    if (!stars) return;
    const label = stars.getAttribute('aria-label');
    const source = ratingSources.get(stars);
    const match = label === source?.label ? null : label?.match(/^(\d+(?:\.\d+)?) out of \d+ stars$/);
    const value = match ? Number(match[1]) : source?.value;
    if (!Number.isFinite(value) || value < 1 || value > 5) return;
    const precise = value.toFixed(2);
    const localizedLabel = section.dataset.ratingLabel.replace('__RATING__',precise);
    ratingSources.set(stars,{value,label:localizedLabel});
    const score = widget.querySelector('.jm-average-rating-display .jm-cluster > span.jm-text');
    if (score && score.textContent !== precise) score.textContent = precise;
    if (label !== localizedLabel) stars.setAttribute('aria-label',localizedLabel);
  };
  const connectRatings = (section,state) => {
    section.querySelectorAll('.jdgm-reviews-grid-widget').forEach(widget => {
      if (state.ratingObservers.has(widget)) return;
      preciseRating(section,widget);
      const observer = new MutationObserver(() => preciseRating(section,widget));
      observer.observe(widget,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label']});
      state.ratingObservers.set(widget,observer);
    });
    state.ratingObservers.forEach((observer,widget) => {
      if (section.contains(widget)) return;
      observer.disconnect();
      state.ratingObservers.delete(widget);
    });
  };
  const restoreCardFocus = (section,state) => requestAnimationFrame(() => {
    if (!state.controller.signal.aborted && state.previousCard?.isConnected && section.contains(state.previousCard)) state.previousCard.focus({preventScroll:true});
  });
  const initialize = root => {
    sectionsWithin(root).forEach(section => {
      if (sectionStates.has(section)) return;
      const controller = new AbortController();
      const state = {controller,ratingObservers:new Map(),previousCard:null,rootObserver:null,pendingWriteJump:false,writeJumpScheduled:false,jumpRevision:0};
      sectionStates.set(section,state);
      const options = {signal:controller.signal};
      const cancelWriteJump = () => {
        state.pendingWriteJump = false;
        state.writeJumpScheduled = false;
        state.jumpRevision++;
      };
      const scheduleWriteJump = () => {
        if (!state.pendingWriteJump || state.writeJumpScheduled || !section.querySelector('.jdgm-review-card')) return;
        state.writeJumpScheduled = true;
        const revision = state.jumpRevision;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (revision !== state.jumpRevision || controller.signal.aborted || !section.isConnected) return;
          state.writeJumpScheduled = false;
          if (!state.pendingWriteJump || window.location.hash !== '#sj-write-review') return;
          state.pendingWriteJump = false;
          section.querySelector('#sj-write-review')?.scrollIntoView({block:'start',behavior:'auto'});
        }));
      };
      section.addEventListener('click',event => {
        const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
        if (anchor?.getAttribute('href') === '#sj-write-review' && !section.querySelector('.jdgm-review-card')) {
          state.pendingWriteJump = true;
          state.writeJumpScheduled = false;
          state.jumpRevision++;
        }
      },{...options,capture:true});
      document.addEventListener('wheel',cancelWriteJump,{...options,passive:true});
      document.addEventListener('touchstart',cancelWriteJump,{...options,passive:true});
      const form = section.querySelector('[data-sjrh-product]');
      if (form) form.addEventListener('submit',event => {
        event.preventDefault();
        const path = form.querySelector('select').value;
        if (!path) return;
        const destination = new URL(path,window.location.origin);
        if (destination.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(destination.pathname)) return;
        window.location.assign(destination.href);
      },options);
      const rememberCard = event => {
        if (event.type === 'keydown' && event.key !== 'Enter') return;
        const card = event.target instanceof Element ? event.target.closest('.jdgm-review-card') : null;
        if (card && section.contains(card)) state.previousCard = card;
      };
      section.addEventListener('click',rememberCard,{...options,capture:true});
      section.addEventListener('keydown',rememberCard,{...options,capture:true});
      document.addEventListener('keydown',event => {
        if (event.key !== 'Escape' || !section.isConnected) return;
        const dialog = [...document.querySelectorAll('.jdgm-modal.jdgm-widget-revamp .jdgm-modal__content[role="dialog"]')].find(node => node.getAttribute('aria-label') === 'Review Media Gallery' && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        if (!dialog) return;
        const close = dialog.closest('.jdgm-modal.jdgm-widget-revamp')?.querySelector('button.jm-indicator__close[aria-label="Close"]');
        if (!close) return;
        event.preventDefault();
        event.stopPropagation();
        close.click();
        restoreCardFocus(section,state);
      },options);
      document.addEventListener('click',event => {
        const close = event.target instanceof Element ? event.target.closest('.jdgm-modal.jdgm-widget-revamp .jm-indicator__close') : null;
        if (close && section.isConnected) restoreCardFocus(section,state);
        const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
        if (anchor && anchor.getAttribute('href') !== '#sj-write-review') cancelWriteJump();
      },options);
      connectRatings(section,state);
      state.rootObserver = new MutationObserver(records => {
        if (records.some(record => record.addedNodes.length || record.removedNodes.length)) {
          connectRatings(section,state);
          scheduleWriteJump();
        }
      });
      state.rootObserver.observe(section,{childList:true,subtree:true});
    });
  };
  const cleanup = root => sectionsWithin(root).forEach(section => {
    const state = sectionStates.get(section);
    if (!state) return;
    state.controller.abort();
    state.rootObserver?.disconnect();
    state.ratingObservers.forEach(observer => observer.disconnect());
    state.ratingObservers.clear();
    state.previousCard = null;
    state.pendingWriteJump = false;
    state.jumpRevision++;
    sectionStates.delete(section);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(document),{once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
  document.addEventListener('shopify:section:unload',event => cleanup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
